module.exports = __webpack_public_path__ + "static/media/angle-double-right.c9ce1b11.svg";